module.exports = __webpack_public_path__ + "img/img34.ece67fd4.svg";